import React from "react";
import { Link } from "react-router-dom";
import { NavbarBrand, Navbar } from "reactstrap";
import HeaderLogo from "@/components/headerLogo";

const SimpleHeader = () => {
  return (
    <Navbar className="navbar-top" container expand="md">
      <NavbarBrand tag={Link} to="/dashboard">
        <HeaderLogo />
      </NavbarBrand>
    </Navbar>
  );
};

export default SimpleHeader;
